import React from 'react';

const GoalSelector = ({ goals, selected, onSelect }) => {
  return (
    <div className="flex flex-wrap gap-2 justify-center mb-8">
      {Object.entries(goals).map(([key, val]) => (
        <button
          key={key}
          onClick={() => onSelect(key)}
          className={`px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-tighter transition-all ${
            selected === key 
            ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30' 
            : 'bg-gray-100 dark:bg-gray-700 text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-600'
          }`}
        >
          {key.replace('_', ' ')}
        </button>
      ))}
    </div>
  );
};

export default GoalSelector;